module.exports = __webpack_public_path__ + "assets/images/76603307da746d98773fbcf70dff5ba2.png";